import { render, staticRenderFns } from "./DashboardBusiness.vue?vue&type=template&id=24ebdd91&scoped=true&"
import script from "./DashboardBusiness.vue?vue&type=script&lang=js&"
export * from "./DashboardBusiness.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBusiness.vue?vue&type=style&index=0&id=24ebdd91&prod&scoped=true&lang=css&"
import style1 from "./DashboardBusiness.vue?vue&type=style&index=1&id=24ebdd91&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ebdd91",
  null
  
)

export default component.exports